import ApiService from '@common/lib/api/api.service';
import { stringify } from 'query-string';

export const add = params => {
  return ApiService.post(`internetCommerce/user/create`, params);
};

export const getByUserCoupon = params => {
  return ApiService.query(`internetCommerce/coupon`);
};

export const getByUserId = params => {
  console.log(
    `internetCommerce/user/list/${params.status}?${stringify(params)}`,
  );
  return ApiService.query(
    `internetCommerce/user/list/${params.status}?${stringify(params)}`,
  );
};

export const getById = params => {
  return ApiService.query(`internetCommerce/user/detail/${params.id}`);
};

export const getByUuid = params => {
  return ApiService.query(`internetCommerce/user/detail/uuid/${params.uuid}`);
};

export const setClosingById = params => {
  return ApiService.query(`internetCommerce/user/closing/${params.id}`);
};

export const setUserQuotationVisible = params => {
  return ApiService.query(`internetCommerce/user/visible/${params.id}`);
};

export const createQuotation = params => {
  return ApiService.post(`internetCommerce/quotation/create`, params);
};

export const getByAll = params => {
  return ApiService.query(
    `internetCommerce/owner/list/${params.status}?${stringify(params)}`,
  );
  // return ApiService.query(
  //   `internetCommerce/owner/list/${params.status}?${stringify(params)}`,
  //   {
  //     isLoading: false,
  //   },
  // );
};

export const getUserQuotation = params => {
  console.log(`internetCommerce/quotations/?${stringify(params)}`);
  return ApiService.query(
    // `internetCommerce/quotation/list/?${stringify(params)}`,
    `internetCommerce/quotations/?${stringify(params)}`,
  );
};

export const getUserQuotationNew = params => {
  console.log('getUserQuotationNew');
  return ApiService.query(
    `internetCommerce/quotation/list/new/?${stringify(params)}`,
    {
      isLoading: false,
    },
  );
};

export const getQuotationCntCheck = params => {
  return ApiService.query(
    `internetCommerce/owner/quotation/cntCheck/?${stringify(params)}`,
  );
};

export const createApply = params => {
  return ApiService.post(`internetCommerce/internetApply/create`, params);
};

// detail 에서 preview 로 바뀜 ( bm 사장님이 신청서 작성을 요청했는데 없어지면서 수정됨 )
// export const getApplyDetail = params => {
//   return ApiService.query(`internetCommerce/apply/detail/${params.id}`);
// };

export const getApplyDetail = params => {
  console.log('getApplyDetailparams');
  console.log(params);
  if (params.applyMode == 'submit' || params.applyMode == 'icq_detail') {
    console.log(1111111111);
    return ApiService.query(`internetCommerce/apply/preview/${params.id}`);
  } else if (params.applyMode == 'detail' && params.applyType == 'normal') {
    console.log(222222222);
    return ApiService.query(`internetCommerce/apply/preview/${params.id}`);
  } else {
    console.log(333333333);
    return ApiService.query(
      `internetCommerce/apply/detail/${params.id}/?${stringify(params)}`,
    );
  }
};

export const createApplySubmit = params => {
  return ApiService.post(`internetCommerce/internetApply/submit`, params);
};

export const getApplyList = params => {
  return ApiService.query(
    `internetCommerce/apply/list/user/?${stringify(params)}`,
  );
};

export const getOwnerApplyList = params => {
  return ApiService.query(
    `internetCommerce/apply/list/owner/?${stringify(params)}`,
  );
};

export const getApplyNewCount = params => {
  return ApiService.query(
    `internetCommerce/apply/detail/cntNew/?${stringify(params)}`,
  );
};

export const getSupportForecast = params => {
  return ApiService.query(
    `internetCommerce/user/support/forecast/?${stringify(params)}`,
  );
};

export const createDirectSubmit = params => {
  return ApiService.post(`internetCommerce/internetDirect/submit`, params);
};

export const getChatQuotationList = params => {
  return ApiService.query(
    `internetCommerce/chat/quotation/list/${params.chatroomId}`,
  );
};

export const createPromotionSubmit = params => {
  return ApiService.post(
    `internetCommerce/user/promotion/submit/?promotionCode=${params.promotionCode}`,
    params,
  );
};

export const getInternetProducts = params => {
  return ApiService.query(`internet/products?${stringify(params)}`);
};

export const setBookmark = params => {
  return ApiService.put(`internet/products/bookmarks?${stringify(params)}`);
};

export const setViewProductCnt = params => {
  return ApiService.put(`internet/viewProduct?${stringify(params)}`);
};

export const setSelProductCnt = params => {
  return ApiService.put(`internet/selProduct?${stringify(params)}`);
};

// 신청서가 열람되었는지 확인
export const getApplyCheckLimit = params => {
  return ApiService.query(
    `internetCommerce/apply/detail/checkLimit?${stringify(params)}`,
  );
};

// 인터넷 프로모션 목록
export const getInternetCommercePromotion = params => {
  return ApiService.query(`internetCommerce/promotions?${stringify(params)}`);
};

// 인터넷 프로모션 상세
export const getInternetCommercePromotionDetail = params => {
  return ApiService.query(`internetCommerce/promotions/${params.id}`);
};

// 인터넷 프로모션 지원금 정보
export const getInternetCommercePromotionSupport = params => {
  return ApiService.query(`internetCommerce/promotions/${params.id}/support`);
};

// 인터넷 신청서 동일 명의자 중복 여부 확인(사용자)
export const getApplyValidate = params => {
  return ApiService.query(
    `internetCommerce/internetApply/validate?${stringify(params)}`,
  );
};

// 인터넷 신청서 동일 명의자 중복 여부 확인(사장님)
export const getApplyCheckValidate = params => {
  return ApiService.query(
    `internetCommerce/internetApply/check?${stringify(params)}`,
  );
};

//
export const internetCommercePromotionChat = params => {
  return ApiService.post(
    `internetCommerce/promotions/kt2408/apply/?item=${params.item}`,
    params,
  );
};

export const internetCommerceApplyCancel = params => {
  return ApiService.post(`internetCommerce/apply/cancel/${params.id}`, params);
};

export const internetCommerceSupportApplyList = params => {
  return ApiService.query(
    `internetCommerce/apply/support/list?${stringify(params)}`,
  );
};

export const internetCommerceApplyListSimple = params => {
  return ApiService.query(`internetCommerce/apply/simple?${stringify(params)}`);
};

export const setInternetCommerceApplyInstallDate = params => {
  return ApiService.put(
    `internetCommerce/apply/changeInstallDate?${stringify(params)}`,
  );
};

export const setInternetCommerceApplyDeposit = params => {
  return ApiService.post(`internetCommerce/apply/deposit?${stringify(params)}`);
};

export const internetCommerceInstallCost = params => {
  return ApiService.query(`internet/installCost?${stringify(params)}`);
};

export const internetCommerceItems = params => {
  return ApiService.query(`internet/items?${stringify(params)}`);
};

export const insertInternetCommerceItems = params => {
  return ApiService.post(`internet/myItems?${stringify(params)}`);
};

export const internetCommerceMyItems = params => {
  return ApiService.query(`internet/myItems?${stringify(params)}`);
};

export const deleteCommerceMyItems = params => {
  return ApiService.delete(`internet/myItems?${stringify(params)}`);
};

export const updateCommerceMyItemsSort = params => {
  return ApiService.put(`internet/myItems/sort?${stringify(params)}`);
};

export const getInternetRequestCnt = params => {
  return ApiService.query(`internetCommerce/requestCount?${stringify(params)}`);
};

export const getInternetSameCnt = params => {
  return ApiService.query(`internetCommerce/sameCount?${stringify(params)}`);
};
